import { Button, ButtonIcon, ButtonText } from '@gluestack-ui/themed';
import { CircleCheckBig } from 'lucide-react-native';

const SubmitButton = ({
  isDisabled = false, onSubmit = () => {}, label = 'Mark As Done', show = true, ...props
}) => (show ? (
  <Button
    testID="mark-as-done-button"
    isDisabled={isDisabled}
    size="xs"
    h={25}
    action="primary"
    variant="solid"
    {...props}
    onPress={onSubmit}
  >
    <ButtonIcon as={CircleCheckBig} size="sm" $base-mr="$0" $sm-mr="$2" color="$textInverted" />
    <ButtonText $base-display="none" $sm-display="flex" color="$textInverted">
      {label}
    </ButtonText>
  </Button>
) : null);

export default SubmitButton;
